import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { Product } from '../../interfaces/product';
import { FormControl } from '@angular/forms';
import { CartService } from '../../services/cart.service';
import { WishlistService } from '../../services/wishlist.service';
import { CompareService } from '../../services/compare.service';
import { RootService } from '../../services/root.service';
import { HomeshoppingDataService } from 'src/app/services/homeshopping-data.service';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { NavigationService } from 'src/app/services/navigation.service';
import { ShoppingSessionService } from 'src/app/services/shopping-session.service';
import { SharedDataService } from 'src/app/services/shared-data-service.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { elementAt } from 'rxjs';
import { PreferedCommunicationComponent } from 'src/app/modules/dashboard/prefered-communication/prefered-communication.component';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';

export type ProductLayout = 'standard' | 'sidebar' | 'columnar' | 'quickview';

interface intfShoppingConfiguration {
    productDetailId: Number,
    isPopular: boolean,
    isNewArrival: boolean,

    isOutOfStock: boolean,
    errorList: [],
    isNewRecord: boolean,
    isValid: boolean,
    id: number,
    creationTs: any,
    creationUserId: string,
    lastChangeTs: string,
    lastChangeUserId: string,
    statusType: 1,
    error: any,
    canDelete: boolean,
    isDirty: boolean,
    isAddOrModify: boolean,
    state: 0
    isSaleItems: boolean
}
@Component({
    selector: 'app-product',
    templateUrl: './product.component.html',
    styleUrls: ['./product.component.scss'],
})



export class ProductComponent {
    @Input() layout: ProductLayout = 'standard';

    listOfProducts: any[] = [];
    RuleType: any;
    @Input() product: any;
    quantity: FormControl = new FormControl(1);
    addingToCart = false;
    addingToWishlist = false;
    addingToCompare = false;
    productDetailsbyId: any;
    productId: number;
    subCategoryId: 0;
    categoryId: 0;
    cost: 0;
    breadcrumbList: any[];

    productsList: any;
    shoppingSession: any;
    addedToCartProducts: any[] = [];
    productSourceList: any[] = [];
    productDetails: any

    isSaleItems: boolean = false;
    isOutOfStock: boolean = false;
    promotionList: any;


    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private cart: CartService,
        private wishlist: WishlistService,
        private compare: CompareService,
        public root: RootService,
        public homeShoppingDataService: HomeshoppingDataService,
        private route: ActivatedRoute,
        private navigate: NavigationService,
        private shoppingSessionService: ShoppingSessionService,
        private sharedDataService: SharedDataService,
        private lookupDataService: LookupDataServiceService,
        private dialog: MatDialog,

    ) {
        this.route.params.subscribe((params: any) => {
            this.productId = parseInt(params.id);
        });
    }

    ngOnInit(): void {
        setTimeout(() => {
            this.getProductsBySubCategoryId();
        }, 0);
        this.getCart();
        this.getShoppingConfigurationByProductId();
        this.getPromotionList();
    }



    getShoppingConfigurationByProductId() {
        this.homeShoppingDataService
            .getShoppingConfigurationByProductId(this.productId)
            .subscribe((result) => {
                console.log('inside line 88', result);

                if (result) {
                    this.isSaleItems = false;
                    this.isOutOfStock = false;
                    if (result.isSaleItems) {
                        this.isSaleItems = true;
                    }
                    if (result.isOutOfStock) {
                        this.isOutOfStock = true;
                    }
                }
            });
    }

    getCart() {
        this.homeShoppingDataService
            .GetCart()
            .subscribe((result: any[]) => {
                if (result != null && result.length > 0) {

                    this.listOfProducts = result;
                    this.shoppingSessionService.setSharedData(this.listOfProducts);
                    console.log('product list : ', this.listOfProducts);
                    this.cartCount();
                }
            });
    }

    cartCount() {
        let temp = 0;
        console.log('this.listOfProducts : ', this.listOfProducts);

        this.listOfProducts.forEach(item => {
            console.log('item.quantity : ', item.quantity);
            let afterAdding = temp + item.quantity;
            this.sharedDataService.setValue('listOfProducts', afterAdding);
        });
    }

    getProductsBySubCategoryId(productId?: number): void {
        let postData = {};
        this.productId = productId ? Number(productId) : this.productId;
        postData = {
            productId: this.productId,
        };
        this.homeShoppingDataService
            .getProductsBySubCategoryId(postData)
            .subscribe((response) => {
                if (response) {
                    this.productDetails = response[0];
                    console.log('inside line 180 product list : ', this.productDetails);
                    console.log('inside line 181 product list : ', this.productDetails.cost);

                    this.lookupDataService
                        .getPromotionList()
                        .subscribe((result) => {
                            console.log('inside line 88', result);

                            if (result) {
                                console.log('inside line 112');

                                this.promotionList = result;
                                var temp = Object.assign([], this.promotionList).filter(item => item.productDetailId == this.productDetails.id);
                                this.productDetails.promoPrice = this.productDetails.cost;
                                this.productDetails.cost = this.promotionList.promoPrice;
                                this.productDetails.totalAmount = this.productDetails.promoPrice;

                                console.log('inside line 118 this.productDetails : ', this.productDetails);

                            }
                            else {
                                console.log('inside line 124');

                            }

                        });
                }
            });
    }

    getPromotionList() {

    }

    addToCart(product: any): void {
        this.addToCartValidation(product)


    }
    addToCartValidation(product: any) {
        // debugger
        // let data = {
        //     productDetailId: product.id,
        //     quantity: this.quantity.value
        // }
        // this.homeShoppingDataService.UpdateCart(data).subscribe((res) => {
        //     if (res) {
        //         this.addedSweetAlert(product);
        //         //this.cartCount(product);
        //     } else {
        //     }
        // },
        //     (error) => {
        //         console.error('Error updating cart:', error);
        //     }
        // );
        console.log("product : ", product);

        if (product.isMustHaveAll) {
            this.homeShoppingDataService
                .getProductNameById(product.mustHaveAllIds)
                .subscribe((productList: any[]) => {
                    if (productList != null && productList.length > 0) {
                        var name = "";
                        var productname = "";
                        if (productList.length = 1)
                            productname = "product";
                        else
                            productname = "products";

                        if (productList.length > 0) {
                            productList.forEach(productItem => {
                                if (name)
                                    name = name + ", " + productItem.value;
                                else
                                    name = name + productItem.value;
                            });
                        }

                        const dialogRef = this.dialog.open(PreferedCommunicationComponent, {
                            autoFocus: false,
                            disableClose: true,
                            panelClass: 'mat-dialog',
                            width: " 750px",
                            data: {
                                displayPanel: 'FrogFootLinkStatus',
                                //statusItem: response
                            }
                        });

                        dialogRef.afterClosed().subscribe(preferedType => {
                            if (preferedType != null) {
                                debugger
                                // Handle the data returned from the dialog if needed
                                console.log('afasfasdf');

                                // console.log(preferedType, "*************************");
                                // if (preferedType === '1') {
                                //     this.navigtion.checkCoverage(0);
                                // }
                                // this.dashboardForm.controls['TrackFrogfoot'].setValue('');
                            }

                        });


                    }
                });

        } else if (product.isMustHaveAnyOne) {

        } else if (product.isUnlimitedTalkTime) {

        } else if (product.isLTETopUp) {

        } else {

        }
    }

    // cartCount(product: any) {
    //     if (this.addedToCartProducts.includes(product)) {
    //         return;
    //     }
    //     this.addedToCartProducts.push(product);
    //     this.cart.add(product, 1).subscribe({
    //         complete: () => {
    //             this.addedToCartProducts = this.addedToCartProducts.filter(eachProduct => eachProduct !== product);
    //         }
    //     });

    // }
    addedSweetAlert(product: any) {
        const title = product?.aliasName;
        const text = `Added To Your Cart successfully`;
        const imageUrl = product?.defaultImage || 'images/default_product.png';
        const showCancelButton = true;
        const confirmButtonColor = '#7D32DE';
        const confirmButtonText = 'Continue Shopping';
        const cancelButtonText = 'Go To Cart';

        Swal.fire({
            html: `
                <div style="align-items: center;">
                    <br>
                    <img src="${imageUrl}" style="height: 100px;" alt="Custom Image"/>
                    <br>
                    <br>
                    <h4>${title}</h4>
                    <span style="margin-left: 10px;">${text}</span>
                </div>`,
            imageWidth: 150,
            imageHeight: 150,
            imageAlt: 'Custom Image',
            showCancelButton,
            confirmButtonColor,
            cancelButtonColor: '#7D32DE',
            confirmButtonText,
            cancelButtonText,
        }).then((result) => {
            if (result.isConfirmed) {
                this.navigate.shop();
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                this.navigate.gotocart();
            }
        });
    }

}
